module.exports = __webpack_public_path__ + "static/img/背景板(2).bdc0c9e8.png";